<template>
	<div>
		<el-dialog
		  title="请登录账号"
		  :visible.sync="dialogVisible"
      :lock-scroll="false"
		  width="420px">
			<div class="login-modal-body">
				<div class="signform" style="padding: 0 25px;">
					<div class="pc-login">
            <div class="text-center">
              <!-- <img src="../../../static/images/home/logo.jpg"/> -->
            </div>

						<div class="login-tab">
							<a class="" :class="{active:logType === 1}" href="javascript:;" @click="Logtab(1)">账号密码登录</a>
							<span class="sep">|</span>
							<a :class="{active:logType === 2}" href="javascript:;" @click="Logtab(2)">手机验证码登录</a>
						</div>
						<div class="login-content signform mt30" v-if="logType === 1" style="padding: 0 0px;">
							<div class="form-group">
								<label class="control-label loginstdz" style="left: 10px;">
									<i class="iconfont icon-yonghu"></i>
								</label>
								<input class="form-control" v-model="userAccount" placeholder="账号/手机号码"/>
							</div>
							<div class="form-group">
								<label class="control-label loginstdz" >
									<i class="iconfont icon-icon-"></i>
								</label>
								<input class="form-control" type="password" v-model="userPass" placeholder="登录密码"/>
							</div>
							<div class="form-group">
								<button class="btn btn-primary btn-block" type="submit" @click="userLogin()">登录</button>
							</div>
						</div>
						<div class="login-content signform mt30" v-if="logType === 2" style="padding: 0 0px;">
							<div class="form-group">
								<label class="control-label loginstdz" style="left: 10px;">
									<i class="iconfont icon-yonghu"></i>
								</label>
								<input class="form-control" v-model="mobile" placeholder="手机号码"/>
							</div>
							<div class="form-group">
								<label class="control-label loginstdz" >
									<i class="iconfont icon-icon-"></i>
								</label>
								<input class="form-control" maxlength="6" v-model="code" placeholder="手机验证码"/>
								<a href="javascript:;" class="absolute-right text-blue" @click="getCode()" :class="{disabled:time!=0}">
									{{time === 0?'获取短信验证码':time+'秒后可重新获取'}}
								</a>
							</div>
							<div class="form-group">
								<button class="btn btn-primary btn-block" type="submit" @click="phongLogin">登录</button>
							</div>
						</div>
						<div class="text-center text-light">
							没有账号?
							<a @click="register" href="javascript:;" class="text-blue">立即注册</a>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				dialogVisible:false,
				logType:1,
				userAccount:"",
				userPass:"",
				mobile:"",
				code:"",
				time:0
			}
		},
		methods:{
			Logtab(index){
				this.logType = index
			},
			register(){

			},
			phongLogin(){
				if(this.$fxLink.checkPhone(this.mobile)){
					this.$message({
						message: '手机号格式不正确',
						type: 'warning'
					});
					return
				}
				if(!this.code){
					this.$message({
						message: '请输入验证码',
						type: 'warning'
					});
					return
				}
				this.$api.login_phone({
					phone: this.mobile,
					code:this.code,
					type:1
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						let token = res.data
						localStorage.setItem("token",token)
						this.$api.userInfo({
							token
						}).then(result => {
							if(result.code === 1){
								localStorage.setItem("userInfo",JSON.stringify(result.data))
								window.location.reload();
							}else{
								this.$message({
									message: res.msg,
									type: 'error'
								});
							}
						})
					}else{
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}

				})
			},
			userLogin(){
				if(!this.userAccount){
					this.visibleUser = true
					this.msgUser = '账号/手机不能为空'
					return
				}
				if(!this.userPass){
					this.visiblePass = true
					this.msgPass = '密码不能为空'
					return
				}

				this.$api.login({
					phone: this.userAccount,
					password:this.userPass,
					type:1
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						let token = res.data.token
						localStorage.setItem("token",token)
						this.$api.userInfo({
							token
						}).then(result => {
							if(result.code === 1){
								localStorage.setItem("userInfo",JSON.stringify(result.data))
								window.location.reload();
							}else{
								this.$message({
									message: res.msg,
									type: 'error'
								});
							}
						})
					}else{
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}

				})
			},
			getCode(){
				if(this.$fxLink.checkPhone(this.mobile)){
					this.$message({
						message: '手机号格式不正确',
						type: 'warning'
					});
					return
				}
				if (this.time == 0){

					this.$api.sendSmsCaptcha({
						mobile:this.mobile,
					}).then(res => {
						if(res.code === 1){
							this.$message({
								message: res.msg,
								type: 'warning'
							});
							this.time = 60 ;
							this.interval = setInterval(() => {
								if(this.time == 0){
									clearInterval(this.interval)
									return
								}
								this.time --
							},1000)
						}else{
							this.$message({
								message: res.msg,
								type: 'warning'
							});
							return
						}

					})
				}
			},
		}
	}
</script>

<style>
	.loginstdz{
		margin-top: 5px;

	}
</style>



// WEBPACK FOOTER //
// src/components/common/login/login.vue